import { render, staticRenderFns } from "./inquiry-table.vue?vue&type=template&id=04f625ae&scoped=true"
import script from "./inquiry-table.vue?vue&type=script&lang=ts"
export * from "./inquiry-table.vue?vue&type=script&lang=ts"
import style0 from "./inquiry-table.vue?vue&type=style&index=0&id=04f625ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f625ae",
  null
  
)

export default component.exports